/* Floating purchase bar (tools/theme/buybar). Follows the main product form: the variant id (so the bar's Shopify
   checkout button buys one unit of exactly what the main form shows; there is no quantity selector), the price markup, availability and the button labels.
   Appears once the main Add to cart row has scrolled above the screen; hides while a drawer has locked the page
   (Head West's cart drawer, AAD's cart app, menus). */
(function () {
  function init(bar) {
    const root = bar.closest('[data-aad-pdp]') || document;
    const main = root.querySelector('form.aad-buyform');
    if (!main) return;
    const mainAdd = main.querySelector('[data-aad-add]'), mainId = main.querySelector('[name="id"]'), mainQty = main.querySelector('[name="quantity"]');
    const row = main.querySelector('.aad-qtyrow') || main;
    const price = root.querySelector('[data-aad-price]');
    const id = bar.querySelector('[data-aad-buybar-id]'), qty = bar.querySelector('[data-aad-buybar-qty]');
    const add = bar.querySelector('[data-aad-buybar-add]'), note = bar.querySelector('[data-aad-buybar-note]');
    const barPrice = bar.querySelector('[data-aad-buybar-price]');
    const buyNows = [...root.querySelectorAll('[data-aad-buynow]')].concat([...bar.querySelectorAll('[data-aad-buynow]')]);

    function sync() {
      const off = !mainAdd || mainAdd.disabled;
      if (mainId && id && id.value !== mainId.value) { id.value = mainId.value; id.dispatchEvent(new Event('change', { bubbles: true })); }
      if (mainQty && qty) qty.value = Math.max(1, parseInt(mainQty.value, 10) || 1);
      if (price && barPrice && barPrice.innerHTML !== price.innerHTML) { barPrice.innerHTML = price.innerHTML; barPrice.className = price.className + ' aad-buybar__price'; }
      if (add) { add.disabled = off; add.textContent = (mainAdd && (mainAdd.querySelector('span') || mainAdd).textContent.trim()) || 'Add to cart'; }
      if (note) note.hidden = off;
      buyNows.forEach(b => { b.hidden = off; });
    }
    function locked() {
      const s = getComputedStyle(document.body), h = getComputedStyle(document.documentElement);
      return s.overflow === 'hidden' || h.overflow === 'hidden';
    }
    let past = false;
    function show() {
      const on = past && !locked();
      bar.classList.toggle('is-show', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.documentElement.classList.toggle('aad-buybar-on', on);
      document.documentElement.style.setProperty('--aad-buybar-h', bar.offsetHeight + 'px');
    }

    sync(); show();
    root.addEventListener('click', () => setTimeout(sync, 0));
    root.addEventListener('input', sync); root.addEventListener('change', sync);
    if (mainAdd) new MutationObserver(sync).observe(mainAdd, { attributes: true, childList: true, subtree: true, characterData: true });
    if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });
    /* Right before the bar's checkout button acts, make sure it carries the current selection. */
    ['pointerdown', 'keydown', 'click'].forEach(t => bar.addEventListener(t, sync, true));
    if (add) add.addEventListener('click', () => { sync(); if (mainAdd && !mainAdd.disabled) mainAdd.click(); });
    /* Past the main buttons? Checked on scroll, once per frame (and by an observer where available, as a second signal). */
    let ticking = false;
    function measure() { ticking = false; const was = past; past = row.getBoundingClientRect().bottom < 0; if (past !== was) show(); }
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(() => measure()).observe(row);
    measure();
    const mo = new MutationObserver(show);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('resize', show);
  }
  function boot() { document.querySelectorAll('[data-aad-buybar]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
